<template>
    <div class="gallery-portal grid">
        <cmp-to-top></cmp-to-top>

        <div class="grid--container">

            <div class="grid--row">
                <div class="grid--col gallery-portal--aside">
                </div>
                <div class="grid--col gallery-portal--main">
                    <cmp-breadcrumbs :tree="routeData.breadcrumbs"></cmp-breadcrumbs>
                </div>
            </div>
            <div class="grid--row">
                <div class="grid--col gallery-portal--aside">
                    <cmp-aside-dropdown :container="containers['dropdown-navigation']"></cmp-aside-dropdown>
                </div>
                <div class="grid--col gallery-portal--main">
                    <div class="gallery-portal--main-root">
                        <cmp-gallery-intro class="section" v-if="partials['gallery-intro']"
                                :container="partials['gallery-intro']">
                            <div class="grid--row gallery-portal--mobile-filter">
                                <div class="grid--col gallery-portal--mobile-filter-col">
                                    <cmp-aside-dropdown
                                            facet="mobile"
                                            :container="containers['dropdown-navigation']"></cmp-aside-dropdown>
                                </div>
                            </div>
                        </cmp-gallery-intro>

                        <cmp-main :container="containers.main"></cmp-main>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';
    import routeMixin from 'vue/mixins/route';

    export default {
        mixins: [routeMixin],
        computed: {
            ...mapGetters(['partials']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?3ed110ea